<template>
  <div>
    <h2>{{ meeting.name }}</h2>
    <hr />
    <b-container v-if="showTable" class="mt-5">
      <b-row class="my-4 sticky-multiselect-add-participants align-self-start">
        <b-col v-if="!edit && !selectedMandate">
          <label><h4>Ajouter une personne</h4></label>
          <appMultiselectOwners
            :options="getBOsNotShowedUpAbsentOpts()"
            @onSelect="onSelectMandate"
          />
        </b-col>
        <b-col v-else>
          <label>
            <h3>
              <span class="border-bottom d-flex justify-content-center">
                {{
                  getPersonNameAndGender({
                    personId: currentMandate.building_owner_id,
                  })
                }}
                <span style="font-size: 15px;" class="ml-2 mt-1">
                  <b-badge variant="warning">
                    {{ getUsedMandateTantiemesChargeGenerale(currentMandate.id) }}
                  </b-badge>
                </span>
              </span>
            </h3>
          </label>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-col v-if="selectedMandate" cols="12">
          <b-row>
            <b-col cols="5">
              <label><h5>Type de vote par correnspondence :</h5></label>
              <v-multiselect
                v-model="correspondenceType"
                :disabled="
                  (isMeetingStarted && !addNew && invalidForm) ||
                  selectedMandate.voted_by_correspondence == correspondenceTypes.by_app
                "
                :show-labels="false"
                :options="typeDeCorrespondence"
                :group-select="false"
                placeholder=""
                open-direction="bottom"
                @select="onSelectCorrespondenceType"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title">{{ props.option.name }}</span>
                </template>
                <template slot="singleLabel" slot-scope="{ option }"
                  ><strong>{{ option.name }}</strong></template
                >
              </v-multiselect>
            </b-col>
            <b-col>
              <b-row>
                <b-col>
                  <label><h5>Date de réception</h5></label>
                </b-col>
              </b-row>
              <v-date-picker
                v-if="
                  selectedMandate &&
                  selectedMandate.voted_by_correspondence != correspondenceTypes.by_app
                "
                v-model="reception_date"
                locale="fr"
                mode="date"
                :timezone="timezone"
                :masks="masks"
                @input="setDate"
              >
                <template v-slot="{ inputValue, inputEvents, togglePopover }">
                  <input
                    readonly
                    :disabled="isMeetingStarted && !addNew && invalidForm"
                    class="bg-white border px-2 py-1 rounded"
                    :value="inputValue"
                    @click="togglePopover"
                  />
                </template>
              </v-date-picker>
              <div v-else class="ml-2">
                <b-input
                  type="text"
                  :value="$moment(reception_date).format('DD MMMM YYYY')"
                  readonly
                />
              </div>
            </b-col>
            <b-col>
              <div class="d-flex align-items-end h-100 pb-2">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="invalidForm"
                  :disabled="
                    (isMeetingStarted && !addNew) ||
                    (selectedMandate &&
                      selectedMandate.voted_by_correspondence == correspondenceTypes.by_app)
                  "
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                  @change="setInvalidMandate"
                >
                  Formulaire invalide
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col v-if="selectedMandate && votingTableVisible" class="my-5" cols="12">
          <appVotingTable
            :current-mandate="selectedMandate"
            :current-mandate-id="selectedMandate.mandate_id || selectedMandate.id"
            :is-form-invalid="invalidForm"
            @setVotingTableIsLoading="setVotingTableIsLoading"
            @set-last-mandate="setLastMandateValue"
          />
        </b-col>

        <b-col class="mt-4">
          <b-row class="d-flex justify-content-center text-center">
            <b-col cols="auto">
              <b-button class="button btn-red" @click="cancel">
                <font-awesome-icon class="agv-button-icon" icon="times-circle" />
                <span>{{ $t("general.cancel") }}</span>
              </b-button>
            </b-col>
            <b-col
              v-if="
                selectedMandate &&
                selectedMandate.voted_by_correspondence != correspondenceTypes.by_app
              "
              cols="auto"
            >
              <b-button
                class="button btn-blue"
                :disabled="isLoadingSave || selectedMandate == null || reception_date == null"
                @click="SAVE"
              >
                <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
                <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
                <span>{{ $t("general.enregistrer") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-else>
      <b-row class="my-5">
        <b-col cols="12" class="mb-4">
          <b-button
            class="button btn-blue"
            :disabled="isLoadingSave"
            @click="
              showTable = true;
              saved = false;
            "
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="plus-circle" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("meetings.meeting_correspondence.add_new") }}</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <appCorrespondencePresenceTable
            class="correspondence-page"
            :without-title="true"
            :mandates-by-correspondence="getCorrespondenceMandates()"
            :editable="true"
            @edit="EDIT_MANDATE"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MandateMW from "@/middlewares/Mandate";

import MeetingORM from "@/store/orm-axios/models/Meeting";
import MandateORM from "@/store/orm-axios/models/Mandate";
import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";

import meetingPresenceMixin from "@/mixins/meeting-presence";
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";
import meetingDetailsMixin from "@/mixins/meeting-details";
import minutesMixin from "@/mixins/minutes.js";
import correspondenceVotesMixin from "@/mixins/correspondence-votes";

import VCalendar from "v-calendar/lib/components/calendar.umd";
import VDatePicker from "v-calendar/lib/components/date-picker.umd";
import appMultiselectOwners from "@/components/snippets/MultiselectOwners";
import MeetingCorrespondenceVoteORM from "@/store/orm-axios/models/MeetingCorrespondenceVote";
import MeetingCorrespondenceVoteMW from "@/middlewares/MeetingCorrespondenceVote";

import { defaultSansVoteMajorityId } from "@/constants/default.js";

export default {
  components: {
    appVotingTable: () =>
      import("@/components/meetings/meeting-correspondence/SetCorrespondenceVotesTable"),
    appCorrespondencePresenceTable: () =>
      import("@/components/meetings/meeting-presence/CorrespondencePresenceTable"),
    vCalendar: VCalendar,
    vDatePicker: VDatePicker,
    appMultiselectOwners,
  },
  mixins: [
    minutesMixin,
    meetingPresenceMixin,
    meetingDetailsMixin,
    meetingPresenceSelectOptionsMixins,
    correspondenceVotesMixin,
  ],
  data() {
    return {
      defaultSansVoteMajorityId,
      invalidForm: false,
      showTable: false,
      addNew: false,
      edit: false,
      saved: false,
      isLoadingSave: false,
      selectedMandate: null,
      votingTableVisible: true,
      correspondenceType: null,
      reception_date: null,
      meeting: null,
      lastMandate: null,
      // typeDeCorrespondence: ["Par Email", "Par la Poste"],
      typeDeCorrespondence: [
        {
          name: "Par Email",
          value: "by_email",
          index: 2,
        },
        {
          name: "Par la Poste",
          value: "by_post",
          index: 3,
        },
      ],
      masks: {
        input: ["DD MMMM YYYY", "YYYY-MM-DD", "YYYY/MM/DD"],
      },
    };
  },
  computed: {
    currentMandate() {
      if (this.$_.isObject(this.selectedMandate)) {
        var building_owner_id = this.selectedMandate.id;
        if (this.edit) {
          building_owner_id = this.selectedMandate.building_owner_id;
        }
        return MandateORM.query()
          .where("building_owner_id", building_owner_id)
          .where("meeting_id", this.$route.params.id)
          .first();
      } else {
        return null;
      }
    },
    mandatesByCorrespondence() {
      var self = this;
      return MandateORM.query()
        .where(mandate => {
          return (
            mandate.meeting_id == this.meeting.id &&
            (mandate.presence_status == self.mandatePresenceStatuses.correspondence ||
              mandate.presence_status == self.mandatePresenceStatuses.invalid_correspondence)
          );
        })
        .get();
    },
    meetingCorrespondenceVotes() {
      return MeetingCorrespondenceVoteORM.query()
        .where("mandate_id", this.currentMandate.id)
        .first();
    },
    timezone() {
      return localStorage.getItem("timezone");
    },
  },
  watch: {
    currentMandate() {
      // Update invalid_correspondence form checkbox
      this.isMandateInvalide();
    },
  },
  async created() {
    this.$store.state.showLoaderOverlay = true;

    this.meeting = MeetingORM.find(this.$route.params.id);

    this.$store.state.showLoaderOverlay = false;
    if (this.timezone) {
      this.$moment.tz.setDefault(this.timezone);
    }
  },
  async beforeDestroy() {
    // ???: ??
    /*
     * If component is destroyed and last mode was addNew || edit,
     * then update mandate value to the initial values from lastMandate (which is currentMandate but with the initial values)
     * (if not doing this, vuex will keep the changes until the page refreshes, but without updateing the API)
     */
    this.resetUnregisteredStoreValues();
  },
  methods: {
    onChangeSelectedMandate($ev) {
      this.votingTableVisible = false;
    },
    EDIT_MANDATE(mandate) {
      mandate = MandateORM.query().where("id", mandate.id).first();
      this.selectedMandate = mandate;
      var index = this.$_.findIndex(this.typeDeCorrespondence, {
        index: mandate.voted_by_correspondence,
      });
      if (index != -1) {
        this.correspondenceType = this.typeDeCorrespondence[index];
      }
      this.reception_date = mandate.reception_date;
      this.showTable = true;
      this.edit = true;
    },
    setVotingTableIsLoading(value) {
      this.$store.state.showLoaderOverlay = value;
    },
    datecheck(date) {
      if (date) {
        if (new Date(date) < new Date()) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    setDate() {
      this.reception_date = this.$moment(this.reception_date).utc().format("YYYY-MM-DDTHH:mm:ssZ");
      MandateORM.update({
        where: this.currentMandate.id,
        data: {
          reception_date: this.reception_date,
        },
      });
    },
    deleteUncreatedResolutionVotes() {
      if (this.$_.isObject(this.currentMandate)) {
        var votes = ResolutionVoteORM.query().where("mandate_id", this.currentMandate.id).get();
        for (let i = 0; i < votes.length; i++) {
          if (votes[i] && (votes[i].id.includes("uid") || votes[i].created == null)) {
            ResolutionVoteORM.delete(votes[i].id);
            // console.log("vote deleted:", votes[i]);
          }
        }
      }
    },
    onSelectCorrespondenceType($ev) {
      MandateORM.update({
        where: this.currentMandate.id,
        data: {
          presence_status: this.mandatePresenceStatuses.correspondence,
          voted_by_correspondence: this.correspondenceTypes[$ev.value],
        },
      });
    },
    SAVE() {
      this.isLoadingSave = true;

      // Check every vote and set to nsp if tantiemes is greater than 0
      this.setNspOnNotVotedCorrespondence();
      this.createResolutionVotes();

      var mandate = MandateORM.query()
        .where("id", this.currentMandate.id)
        .with("resolution_votes", query => {
          query.where(rv => {
            // !!!: ignore resolution votes with revote_majority, because are only for visualisation purpose
            return !rv.revote_majority;
          });
        })
        .first();
      // Set mandateId for api
      mandate["mandateId"] = mandate.id;

      MandateMW.MANDATE_CORRESPONDENCE_VOTING(mandate)
        .then(async res => {
          this.isLoadingSave = false;
          if (!res.success) {
            return this.$swal(this.alertError());
          }
          this.saved = true;

          await MeetingCorrespondenceVoteMW.PUT(this.meetingCorrespondenceVotes);

          if (this.isMeetingStarted) {
            await this.setCorrespondenceEvent(mandate.id, this.invalidForm, true);
            if (mandate.presence_status != this.mandatePresenceStatuses.invalid_correspondence) {
              await this.updateMeetingVotesNeedRecalculations();
            }
          }

          this.$swal({
            title: "",
            text: "Des votes ont été ajoutés",
            icon: "success",
            timer: 3000,
          }).then(r => {
            this.setValuesToDefault();
          });
        })
        .catch(err => {
          console.log("error happened", err);
          this.isLoadingSave = false;
        });
    },
    setNspOnNotVotedCorrespondence() {
      let proposedVotes = this.meetingCorrespondenceVotes.proposed_votes;
      if (proposedVotes && proposedVotes.length > 0) {
        proposedVotes.forEach(proposed_vote => {
          proposed_vote.vote = proposed_vote.vote == null ? this.voteTypes.nsp : proposed_vote.vote;
        });
        MeetingCorrespondenceVoteORM.update({
          where: this.meetingCorrespondenceVotes.id,
          data: {
            proposed_votes: proposedVotes,
          },
        });
      }
    },
    createResolutionVotes() {
      let meetingResolutions = MeetingResolutionORM.query()
        .where("meeting_id", this.$route.params.id)
        .hasNot("children_resolutions")
        .orderBy("position")
        .get();
      let proposedVotes = this.meetingCorrespondenceVotes.proposed_votes;
      if (proposedVotes && proposedVotes.length > 0) {
        meetingResolutions.forEach(meetingResolution => {
          let vote = this.$_.find(proposedVotes, item => {
            return (
              item.meeting_resolution_id == meetingResolution.id &&
              item.majority_id == meetingResolution.majority_id
            );
          });
          let existentVote = ResolutionVoteORM.getters("getResolutionVoteByMandateAndResolution")(
            this.currentMandate.id,
            meetingResolution.id
          );
          if (vote && !existentVote) {
            ResolutionVoteORM.insertOrUpdate({
              data: {
                meeting_has_resolution_id: meetingResolution.id,
                mandate_id: this.currentMandate.id,
                vote: null,
                presence_status: this.currentMandate.presence_status,
                agency_id: Number(localStorage.getItem("agencyId")),
              },
            });
          }
        });
      }
    },
    setValuesToDefault() {
      this.showTable = false;
      this.addNew = false;
      this.isLoadingSave = false;
      this.selectedMandate = null;
      this.correspondenceType = null;
      this.reception_date = null;
      this.edit = false;
    },
    onSelectMandate(e) {
      this.selectedMandate = e;
      this.votingTableVisible = true;
      this.addNew = true;
    },
    cancel() {
      this.resetUnregisteredStoreValues();
      this.setValuesToDefault();
    },
    resetUnregisteredStoreValues() {
      // ???: ??
      if ((this.addNew || this.edit) && this.lastMandate && !this.saved) {
        MandateORM.update({
          where: this.lastMandate.id,
          data: this.lastMandate,
        });
      }

      this.deleteUncreatedResolutionVotes();
    },
    setInvalidMandate(isInvalid) {
      let mandate = MandateORM.query().where("id", this.currentMandate.id).first();
      if (isInvalid) {
        mandate.presence_status = this.mandatePresenceStatuses.invalid_correspondence;
        MandateORM.update({
          where: this.currentMandate.id,
          data: mandate,
        });
      } else {
        mandate.presence_status = this.mandatePresenceStatuses.correspondence;
        MandateORM.update({
          where: this.currentMandate.id,
          data: mandate,
        });
      }
    },
    isMandateInvalide() {
      if (
        this.currentMandate &&
        this.currentMandate.presence_status == this.mandatePresenceStatuses.invalid_correspondence
      ) {
        this.invalidForm = true;
      } else {
        this.invalidForm = false;
      }
    },
    setLastMandateValue(lastMandate) {
      this.lastMandate = lastMandate;
    },
    getCorrespondenceMandates() {
      // NOTE: If meeting is started, get initial correspondence events from minutes
      if (this.isMeetingStarted) {
        const minutesCorrespondenceEvents = this.getCorrespondenceEvents();
        let mandates = [];
        for (const correspondenceEvent of minutesCorrespondenceEvents) {
          const mandate = MandateORM.getters("getById")(correspondenceEvent.mandate_id);
          mandates.push(mandate);
        }
        return mandates;
      } else {
        return this.mandatesByCorrespondence;
      }
    },
  },
};
</script>
